import React from "react";
import { Outlet, Link } from "react-router-dom";
import "../../../styles/styles.css";

export default function Contabilidad() {
  return (
    <div style={{ padding: '0', margin: '0', width: '100%', height: '100%' }}>
      <Outlet />
    </div>
  );
}
